// src/pages/CategoryPage.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
//import { fetchCategories } from '../redux/reducers/queroComprar';
import { Row, Col, Card, Form, Button, Container, Nav, Modal } from 'react-bootstrap';
import '../style/querocomprar.css';
import MenuPrincipal from "../components/menuPrincipal";
import Breve from "../components/breve";
import LoadingOverlay from "../components/loading";
import { fetchCategories2 } from '../redux/reducers/categoriesSlice';
import { fetchProducts, filterProduct, fetchFilteredProducts, fetchAllProducts } from '../redux/reducers/produtoSlice';
import { addProductToCart } from '../redux/reducers/cartSlice';
import Rodape from "../components/rodape";
import PaginationComponent from '../components/paginacao';
import oferta from '../assets/imagens/melhor_oferta.png'
const BASE_URL = process.env.REACT_APP_BASE_URL

const CategoryPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { typesApi2, modelos } = useSelector((state) => state.categories);
    const [activeTheme, setActiveTheme] = useState('all'); // "all" como padrão para "Todos"
    const [showModal, setShowModal] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState({
        modelos: [],    // Array para armazenar os IDs de modelos selecionados
        atributos: []   // Array para armazenar os IDs de atributos selecionados
    });
    const [showMore, setShowMore] = useState({});
    const [selectProdCar, setSelectProdCar] = useState();
    const { products, totalPage, loading4, filter } = useSelector((state) => state.produtos);
    console.log(useSelector((state) => state.produtos, 'useSelector((state) => state.produtos'))
    //console.log(useSelector((state) => state.categories, 'useSelector((state) => state.categories'))
    //Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9; // Define quantos itens serão exibidos por página
    const totalPages = Math.ceil(totalPage / itemsPerPage);


    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    const toggleShowMore = (attributeName) => {
        setShowMore((prevState) => ({
            ...prevState,
            [attributeName]: !prevState[attributeName],
        }));
    };

    const handleThemeClick = (theme) => {
        setActiveTheme(theme.id);
        setSelectedFilters({ modelos: [], atributos: [] })
        dispatch(filterProduct(theme.id));
    };

    const handleAllProducts = () => {
        setActiveTheme('all'); // Define "all" como o tema ativo
        setSelectedFilters({ modelos: [], atributos: [] })
        dispatch(fetchAllProducts(currentPage)); // Despacha a ação para buscar todos os produtos
    };

    const handleFilterChange = (filterType, value, isChecked) => {
        setSelectedFilters((prevFilters) => {
            // Cria uma cópia do estado anterior
            const updatedFilters = { ...prevFilters };
            // Garantir que os arrays existam antes de tentar manipular
            if (!updatedFilters.modelos) updatedFilters.modelos = [];
            if (!updatedFilters.atributos) updatedFilters.atributos = [];
            // Atualiza o array correto (modelos ou atributos) com base no `filterType`
            if (filterType === 'modelo') {
                if (isChecked) {
                    updatedFilters.modelos.push(value);  // Adiciona o valor ao array de modelos
                } else {
                    updatedFilters.modelos = updatedFilters.modelos.filter((item) => item !== value);  // Remove o valor
                }
            } else if (filterType === 'atributo') {
                if (isChecked) {
                    updatedFilters.atributos.push(value);  // Adiciona o valor ao array de atributos
                } else {
                    updatedFilters.atributos = updatedFilters.atributos.filter((item) => item !== value);  // Remove o valor
                }
            }
            // Retorna o estado atualizado
            return updatedFilters;
        });
    };

    const handleAddToCart = (product) => {
        console.log(product, 'product')
        dispatch(addProductToCart(product));
        setShowModal(true);
        setSelectProdCar(product)
    };

    const applyFilters = () => {
        if (activeTheme === 'all') {
            dispatch(fetchFilteredProducts({ filters: selectedFilters })); // Busca com todos os filtros
        } else {
            dispatch(fetchFilteredProducts({ filters: selectedFilters, typeId: activeTheme }));
        }
    };

    const formatProductName = (name) => {
        return name
            .normalize("NFD") // Normaliza para decompor acentos
            .replace(/[\u0300-\u036f]/g, "") // Remove acentos
            .replace(/\s+/g, '-') // Substitui espaços por hifens
            .toLowerCase();
    };

    const handleViewDetails = (sku, nome) => {
        const formattedName = formatProductName(nome);
        navigate(`/produto/${sku}/${formattedName}`);
    };

    const getIconClassForAttribute = (attributeName) => {
        // Lista de mapeamento de atributos para classes de ícones
        const attributeIconMap = {
            'bateria': 'fa-solid fa-battery-full',
            'câmera': 'fa-solid fa-camera',
            'memória': 'fa-solid fa-memory',
            'conectividade': 'fa-solid fa-wifi',
            'bluetooth': 'fa-solid fa-bluetooth',
            'tela': 'fa-solid fa-mobile-alt',
            'processador': 'fa-solid fa-cogs',
            'cores': 'fa-solid fa-palette',
            'carregador': 'fa-solid fa-plug',
            'carregamento': 'fa-solid fa-plug-circle-exclamation',
            'acessórios': 'fa-solid fa-box-open',
            'capacidade': 'fa-solid fa-hdd',
            'sistema operacional': 'fa-brands fa-android', // ou 'fa-brands fa-apple' para iOS
            'resolução': 'fa-solid fa-expand',
            'peso': 'fa-solid fa-weight',
            'dimensões': 'fa-solid fa-ruler-combined',
            'sensor': 'fa-solid fa-fingerprint',
            'frequência': 'fa-solid fa-signal',
            'áudio': 'fa-solid fa-headphones-alt',
            'material': 'fa-solid fa-boxes',
            'garantia': 'fa-solid fa-shield-alt',
            'dual sim': 'fa-solid fa-sim-card',
            'resistência à água': 'fa-solid fa-water',
            // Adicione outros atributos conforme necessário
        };
        // Formata o nome do atributo para buscar no mapa (converte para minúsculas)
        const key = attributeName.toLowerCase();
        // Retorna a classe correspondente ou uma classe padrão
        return attributeIconMap[key] || 'fa-solid fa-check';
    };
    useEffect(() => {
        dispatch(fetchCategories2()); // Busca os dados ao montar o componente
        handleAllProducts();
    }, [dispatch, currentPage]);

    useEffect(() => {
        //alert(activeTheme)
        if (activeTheme != 'all') {
            dispatch(fetchProducts());
            dispatch(filterProduct(typesApi2[0]?.id));
        }
    }, [dispatch, typesApi2]);

    return (
        <div>
            <MenuPrincipal />
            <Breve/>
            {/* Filtros e Ordenação */}
           {/* <div className={`box-2 loading ${loading4 ? 'loading-active' : ''}`}>
                <LoadingOverlay loading={loading4} />
                <div className="section-spacing-3">
                    <Container>
                        <div className='nav2'>
                            <Nav className="theme-menu d-flex justify-content-between align-items-center">
                                {/* Adiciona a opção "Todos" no menu */}
                              {/*  <Nav.Item className="theme-item">
                                    <div
                                        className={`theme-link ${activeTheme === 'all' ? 'active' : ''}`}
                                        onClick={handleAllProducts}
                                        role="button"
                                    >
                                        Todos
                                    </div>
                                </Nav.Item>
                                {/* Mapeia os temas disponíveis */}
                              {/*  {typesApi2?.map((theme) => (
                                    <Nav.Item key={theme.id} className="theme-item">
                                        <div
                                            className={`theme-link ${activeTheme === theme.id ? 'active' : ''}`}
                                            onClick={() => handleThemeClick(theme)}
                                            role="button"
                                        >
                                            {theme.name}
                                        </div>
                                    </Nav.Item>
                                ))}
                            </Nav>
                        </div>
                    </Container>
                </div>
                <section className='section-spacing-4'>
                    <Row className="mb-4">
                        <Col md={3}>
                            <h4><i style={{ color: '#ff751a' }} class="fa-solid fa-sliders"></i> Filtros</h4>
                            <Form className='form-filter'>
                                {/*<Form.Group className="mb-3">
                                    <Form.Label>Marca</Form.Label>
                                    <Form.Select>
                                        <option>Todas</option>
                                        <option>Samsung</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Preço</Form.Label>
                                    <Form.Range />
                                    <div className="price-range">
                                        <span>R$500</span> - <span>R$5000</span>
                                    </div>
                                </Form.Group>*/}

                             {/*   <div className='filter-container'>
                                    <Form.Group className="mb-3">
                                        <Form.Label><i style={{ color: '#ff751a' }} class="fa-solid fa-bars-staggered"></i> Modelos</Form.Label>
                                        {modelos.map((item2) => (
                                            <Form.Check
                                                type="checkbox"
                                                label={item2.name}
                                                key={item2.id}
                                                onChange={(e) => handleFilterChange('modelo', item2.id, e.target.checked)}
                                            />
                                        ))}
                                    </Form.Group>*/}

                                    {/* Seção de filtros dinâmicos */}
                                {/*    {filter?.map((item) => (
                                        <Form.Group className="mb-3" key={item.name}>
                                            <Form.Label><i style={{ color: '#ff751a' }} className={getIconClassForAttribute(item.name)}></i> {item.name}</Form.Label>

                                            {/* Exibe apenas os primeiros 10 itens ou todos, dependendo do estado showMore */}
                                       {/*     {item.attribute_values.slice(0, showMore[item.name] ? item.attribute_values.length : 10).map((item2) => (
                                                <Form.Check
                                                    type="checkbox"
                                                    label={item2.value}
                                                    key={item2.id}
                                                    onChange={(e) => handleFilterChange('atributo', item2.id, e.target.checked)}
                                                />
                                            ))}

                                            {/* Botão de "Veja mais" para atributos com mais de 10 valores */}
                                       {/*     {item.attribute_values.length > 10 && (
                                                <Button
                                                    variant="link"
                                                    onClick={() => toggleShowMore(item.name)}
                                                    className={`see-more-btn ${showMore[item.name] ? 'rotated' : ''}`}
                                                >
                                                    {showMore[item.name] ? 'Veja menos' : 'Veja mais'}
                                                    <i class="fa-solid fa-angle-down icone"></i>
                                                </Button>
                                            )}
                                        </Form.Group>
                                    ))}
                                </div>
                                <Button variant="primary" className="w-100" onClick={applyFilters}>Aplicar Filtros</Button>
                            </Form>
                        </Col>
                        {/* Produtos e Ordenação */}
                    {/*    <Col md={9}>
                            {/*<div className="d-flex justify-content-between align-items-center mb-3">
                                <Form.Select className="w-auto">
                                    <option>Ordenar por</option>
                                    <option>Melhor Avaliação</option>
                                    <option>Menor Preço</option>
                                    <option>Maior Preço</option>
                                </Form.Select>
                            </div>*/}

                            {/* Lista de Produtos */}
                       {/*     <div className='d-flex justify-content-center'>
                                {activeTheme === 'all' && (
                                    <PaginationComponent
                                        currentPage={currentPage}
                                        lastPage={totalPages}
                                        onPageChange={handlePageChange}
                                    />
                                )}
                            </div>
                            <Row>
                                {products?.data?.map((product) => (
                                    <Col xs={12} md={4} key={product} className='card-space'>
                                        <Card className="product-card h-100  position-relative" style={{ borderLeft: '3px solid #ff751a' }}>
                                            {/* Tag de Oferta Especial *
                                            {product.discount_price && (
                                                <span className="badge special-offer">Oferta Especial</span>
                                            )}*/}

                                            {/* Tag de Produto Novo */}
                                 {/*          {product.is_new && !product.discount_price && (
                                                <span className="badge new-product">Produto Novo</span>
                                            )}

                                            {/* Tag de Produto Esgotado */}
                                 {/*           {product.stock === 0 && (
                                                <span className="badge out-of-stock">Produto Esgotado</span>
                                            )}
                                            {product.selected_attributes?.filter((attr) => attr.name === 'Estado')
                                                .slice(0, 1) // Garante que o ícone será renderizado apenas uma vez
                                                .map((attr) => (

                                                    <span className="badge-2">
                                                        <i className="fa-solid fa-award" style={{ fontSize: '1.2em' }}></i>  {attr.selected_attribute_values.map((value) => value.value).join(' - ')}
                                                    </span>

                                                ))}
                                            <Card.Img
                                                variant="top"
                                                onClick={() => handleViewDetails(product.SKU, product.name)}
                                                src={
                                                    product.images && product.images[0]?.url
                                                        ? product.images[0].url.startsWith("data:image") // Verifica se é base64
                                                            ? product.images[0].url // Base64
                                                            : `${BASE_URL}storage/${product.images[0].url}` // Caminho no servidor
                                                        : "default-image-path" // Caminho para uma imagem padrão
                                                }
                                                alt="Produto"
                                                className="product-img"
                                            />
                                            <Card.Body className="d-flex flex-column"  >
                                                <Card.Title className="product-title">{product.name}</Card.Title>
                                                <Card.Text className="product-price">{Number(product.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Card.Text>
                                                {/*<div className='d-flex flex-column  align-items-center'>
                                                    {product?.selected_attributes && (
                                                        <>
                                                           
                                                            {product.selected_attributes
                                                                .filter((attr) => attr.name === 'Capacidade')
                                                                .slice(0, 1) // Garante que o ícone será renderizado apenas uma vez
                                                                .map((attr) => (
                                                                    <div className="attribute-container" key={attr.name}>
                                                                        <i className="fa-solid fa-hdd attribute-icon"></i>
                                                                        <span className="attribute-text">
                                                                            {attr.name}: {attr?.selected_attribute_values.map((value) => value.value).join(' - ')}
                                                                        </span>
                                                                    </div>
                                                                ))}

                                                            
                                                            {product.selected_attributes
                                                                .filter((attr) => attr.name === 'Tela')
                                                                .map((attr) => (
                                                                    <div className="attribute-container" key={attr.name}>
                                                                        <i className="fa-solid fa-mobile-alt attribute-icon"></i>
                                                                        <span className="attribute-text">
                                                                            {attr.name}: {attr?.selected_attribute_values.map((value) => value.value).join(' - ')}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                        </>
                                                    )}
                                                </div>*/}
                                     {/*           <div className="button-group mt-auto">
                                                    <Button
                                                        variant="primary"
                                                        onClick={() => handleAddToCart(product)}
                                                        className="btn-buy-2 mt-3"
                                                    >
                                                        Comprar
                                                    </Button>
                                                    {/*<Button
                                                        variant="outline-primary"
                                                        onClick={() => handleViewDetails(product.SKU, product.name)}
                                                        className="btn-details"
                                                    >
                                                        Ver Detalhes
                                                    </Button>*/}
                                          {/*      </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </section>
            </div>
            <Modal show={showModal} onClick={() => setShowModal(false)} centered className="custom-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Já adicionamos seu produto no carrinho</Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex flex-column align-items-center">
                    <img
                        alt={selectProdCar?.name}
                        className="product-image mb-3"
                        style={{ maxWidth: '150px' }}
                        src={
                            selectProdCar?.images[0]?.url
                                ? selectProdCar.images[0].url.startsWith("data:image") // Verifica se é base64
                                    ? selectProdCar.images[0].url // Base64
                                    : `${BASE_URL}storage/${selectProdCar.images[0].url}` // Caminho no servidor
                                : "default-image-path" // Caminho para uma imagem padrão
                        }
                    />

                    <h5>{selectProdCar?.name}</h5>
                    <p className="text-muted">
                        {Number(selectProdCar?.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => window.location.href = '/carrinho'}>
                        Ir para o Carrinho
                    </Button>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Continuar Comprando
                    </Button>
                </Modal.Footer>
            </Modal>*/}
            <Rodape />
        </div>
    );
};

export default CategoryPage;
